import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import appConfigCoverGoProd from "./appConfigCoverGoProd"
import { COVERGO_ASIA_PROD } from "../consts.js"

export const apex = {
	// Dev
	"apex-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PROD },

	// Prod
	"apex-studio.quote.hk": { appConfig: appConfigCoverGoProd, envConfig: COVERGO_ASIA_PROD }
}
